module.exports = __webpack_public_path__ + "img/thumbnail.15dd3ba9.png";